// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Planning stations — swimlane board */

.psg-board {
  --psg-ease: cubic-bezier(0.25, 1, 0.5, 1);
  --psg-rail: 148px;
  --psg-px: 7px;
  margin: 0 0 16px;
  padding: 0;
  border-radius: 16px;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  box-shadow: 0 8px 28px var(--shadow-color);
  overflow: hidden;
  color: var(--text-color);
}

.psg-board__hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 12px;
  padding: 10px 14px;
  background:
    linear-gradient(
      135deg,
      color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent) 0%,
      transparent 58%
    );
  border-bottom: 1px solid var(--border-color);
}

.psg-board__hero--toolbar {
  align-items: center;
}

.psg-board__titles {
  flex: 1 1 14rem;
  min-width: 0;
}

.psg-board__kicker {
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.psg-board__title {
  margin: 0;
  font-size: 20px;
  font-weight: 750;
  letter-spacing: -0.03em;
  line-height: 1.2;
  color: var(--text-color);
}

.psg-board__meta {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  flex: 1 1 auto;
  min-width: 0;
}

.psg-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 650;
  line-height: 1.2;
  background: var(--bg-color);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
}

.psg-chip--warn {
  color: #b26a00;
  background: color-mix(in srgb, #ff9f0a 18%, var(--bg-color));
  border-color: color-mix(in srgb, #ff9f0a 45%, var(--border-color));
}

.psg-board__hero-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
  max-width: 100%;
  min-width: 0;
}

.psg-board__split {
  box-sizing: border-box;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: auto;
  max-width: 100%;
  min-height: 40px;
  padding: 8px 12px;
  border: none;
  border-radius: 12px;
  font: inherit;
  font-size: 13px;
  font-weight: 750;
  letter-spacing: -0.01em;
  line-height: 1.2;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877bc) 0%,
    var(--brand-primary-dark, #065a8f) 100%
  );
  box-shadow: 0 4px 14px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.32);
  transition: transform 0.2s var(--psg-ease), box-shadow 0.2s ease;
}

.psg-board__split-icon {
  flex-shrink: 0;
}

.psg-board__split-label {
  display: inline;
  min-width: 0;
  text-align: center;
  white-space: nowrap;
}

.psg-board__split:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4);
}

.psg-board__split:active {
  transform: scale(0.97);
}

.psg-board__split:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.psg-board__split:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.psg-board__split--ghost {
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color));
  box-shadow: none;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--border-color));
}

.psg-focus {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-color);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color));
}

.psg-focus__copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
}

.psg-focus__station {
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.psg-focus__block {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--text-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.psg-focus__block--muted {
  font-weight: 600;
  color: var(--text-secondary);
}

.psg-focus__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.psg-focus__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 36px;
  padding: 6px 12px;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, var(--border-color));
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));
  color: var(--brand-primary, #0877bc);
  font: inherit;
  font-size: 12px;
  font-weight: 750;
  cursor: pointer;
}

.dark-mode .psg-focus__btn,
html[data-theme="dark"] .psg-focus__btn {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color));
  color: color-mix(in srgb, var(--brand-primary, #0877bc) 50%, #fff);
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 38%, transparent);
}

.template-apply-choice {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  text-align: left;
  padding: 14px 16px;
  border-radius: 14px;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, var(--border-color));
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color, #fff));
  color: var(--text-color, #1a1a1a);
  font: inherit;
  cursor: pointer;
}

.template-apply-choice strong {
  font-size: 15px;
  font-weight: 750;
}

.template-apply-choice span {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary, #555);
}

.template-apply-choice--primary {
  color: #fff;
  border: none;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877bc) 0%,
    var(--brand-primary-dark, #065a8f) 100%
  );
}

.template-apply-choice--primary span {
  color: rgba(255, 255, 255, 0.88);
}

.psg-focus__btn--primary {
  color: #fff;
  border: none;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877bc) 0%,
    var(--brand-primary-dark, #065a8f) 100%
  );
}

.psg-focus__btn--ghost {
  color: var(--brand-primary, #0877bc);
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--border-color));
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));
}

.psg-focus__btn--danger {
  color: #c62828;
  border-color: color-mix(in srgb, #c62828 35%, var(--border-color));
  background: color-mix(in srgb, #c62828 10%, var(--surface-color));
}

.psg-board__scroll {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 8px 12px 16px;
}

.psg-board__grid {
  min-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

@media (min-width: 720px) {
  .psg-board__grid {
    min-width: calc(var(--psg-rail) + var(--psg-track, 280px));
  }

  .psg-ruler__track,
  .psg-lane__track {
    width: var(--psg-track, 280px);
  }

  .psg-block {
    width: var(--psg-block-w, 72px);
  }
}

.psg-ruler {
  display: grid;
  grid-template-columns: var(--psg-rail) 1fr;
  align-items: end;
  min-height: 28px;
  padding: 0 4px 4px;
}

.psg-ruler__label {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-secondary);
  padding-left: 4px;
}

.psg-ruler__track {
  position: relative;
  height: 22px;
}

.psg-ruler__tick {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--text-secondary);
  font-size: 10px;
  font-weight: 650;
}

.psg-ruler__tick::before {
  content: "";
  width: 1px;
  height: 8px;
  margin-bottom: 2px;
  background: var(--border-color);
}

.psg-lane {
  display: grid;
  grid-template-columns: var(--psg-rail) 1fr;
  gap: 8px;
  padding: 8px;
  border-radius: 14px;
  border: 1px solid transparent;
  background: color-mix(in srgb, var(--psg-accent, #0877bc) 7%, var(--bg-color));
  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s var(--psg-ease);
}

.psg-lane:hover {
  background: color-mix(in srgb, var(--psg-accent, #0877bc) 11%, var(--bg-color));
}

.psg-lane--selected {
  border-color: color-mix(in srgb, var(--psg-accent, #0877bc) 55%, var(--border-color));
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--psg-accent, #0877bc) 35%, transparent);
}

.psg-lane--independent .psg-lane__track {
  background-image: repeating-linear-gradient(
    -45deg,
    transparent,
    transparent 7px,
    color-mix(in srgb, var(--psg-accent, #0877bc) 8%, transparent) 7px,
    color-mix(in srgb, var(--psg-accent, #0877bc) 8%, transparent) 14px
  );
}

.psg-lane__identity {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 4px 2px 4px 6px;
  border-left: 4px solid var(--psg-accent, #0877bc);
  border-radius: 0 8px 8px 0;
}

.psg-lane__name-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.psg-lane__name {
  margin: 0;
  font-size: 14px;
  font-weight: 750;
  letter-spacing: -0.02em;
  color: var(--text-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.psg-lane__name-input {
  width: 100%;
  min-width: 0;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--surface-color);
  color: var(--text-color);
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  padding: 4px 8px;
}

.psg-lane__timer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border: 1px solid color-mix(in srgb, var(--psg-accent, #0877bc) 40%, var(--border-color));
  color: var(--psg-accent, #0877bc);
  background: color-mix(in srgb, var(--psg-accent, #0877bc) 12%, var(--surface-color));
  cursor: pointer;
}

.psg-lane__timer:disabled {
  cursor: default;
  opacity: 0.85;
}

.psg-lane__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary);
}

.psg-lane__tables {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.psg-lane__table {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 750;
  letter-spacing: 0.02em;
  color: var(--psg-accent, #0877bc);
  background: color-mix(in srgb, var(--psg-accent, #0877bc) 14%, var(--surface-color));
  border: 1px solid color-mix(in srgb, var(--psg-accent, #0877bc) 32%, var(--border-color));
}

.psg-lane__actions {
  display: flex;
  gap: 4px;
  margin-top: auto;
}

.psg-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 9px;
  border: 1px solid var(--border-color);
  background: var(--surface-color);
  color: var(--text-secondary);
  cursor: pointer;
  transition: transform 0.15s var(--psg-ease), background 0.15s ease, color 0.15s ease;
}

.psg-icon-btn:hover {
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));
}

.psg-icon-btn:active {
  transform: scale(0.94);
}

.psg-icon-btn:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 1px;
}

.psg-icon-btn--danger:hover {
  color: #c62828;
  background: color-mix(in srgb, #c62828 12%, var(--surface-color));
}

.psg-lane__track {
  position: relative;
  display: flex;
  align-items: stretch;
  gap: 6px;
  min-height: 76px;
  padding: 8px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--surface-color) 70%, transparent);
  border: 1px dashed color-mix(in srgb, var(--psg-accent, #0877bc) 28%, var(--border-color));
}

.psg-block {
  position: relative;
  flex: 0 0 auto;
  min-width: 72px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  padding: 8px 10px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--psg-accent, #0877bc) 35%, var(--border-color));
  background: var(--surface-color);
  box-shadow: 0 4px 12px color-mix(in srgb, var(--psg-accent, #0877bc) 16%, transparent);
  cursor: pointer;
  text-align: left;
  color: inherit;
  transition: transform 0.2s var(--psg-ease), box-shadow 0.2s ease;
}

.psg-block__topline {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
}

.psg-block__index {
  flex: 0 0 auto;
  min-width: 1.7rem;
  padding: 1px 5px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--psg-accent, #0877bc) 14%, transparent);
  color: var(--psg-accent, #0877bc);
  font-size: 11px;
  font-weight: 750;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.04em;
  line-height: 1.4;
}

.psg-block__kind {
  min-width: 0;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.01em;
  color: var(--psg-accent, #0877bc);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.psg-block__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.psg-block__seqs {
  font-size: 10px;
  font-weight: 650;
  color: var(--text-secondary);
}

.psg-block:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 18px color-mix(in srgb, var(--psg-accent, #0877bc) 22%, transparent);
}

.psg-block:active {
  transform: scale(0.98);
}

.psg-block:focus-visible {
  outline: 2px solid var(--psg-accent, #0877bc);
  outline-offset: 2px;
}

.psg-block--selected {
  border-color: var(--psg-accent, #0877bc);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--psg-accent, #0877bc) 35%, transparent);
}

.psg-block--mismatch {
  border-color: #ff9f0a;
  box-shadow: 0 0 0 2px color-mix(in srgb, #ff9f0a 45%, transparent);
}

.psg-block--exercise-sync {
  border-left-width: 4px;
  border-left-color: var(--psg-sync, #0d9488);
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--psg-sync, #0d9488) 12%, var(--surface-color)) 0,
    var(--surface-color) 18px
  );
}

.psg-block--personalized {
  border-left-width: 4px;
  border-left-color: var(--brand-primary, #0877bc);
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color)) 0,
    var(--surface-color) 22px
  );
  box-shadow:
    0 4px 12px color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent),
    inset 0 0 0 1px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
}

.psg-block--personalized .psg-block__kind {
  color: var(--brand-primary, #0877bc);
  font-weight: 800;
}

.psg-block--finalized {
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, #94a3b8);
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color)) 0%,
    color-mix(in srgb, var(--brand-primary, #0877bc) 5%, var(--surface-color)) 55%,
    var(--surface-color) 100%
  );
  box-shadow:
    0 4px 12px color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent),
    inset 0 0 0 1px color-mix(in srgb, var(--brand-primary, #0877bc) 18%, transparent);
  opacity: 0.92;
}

.psg-block--finalized .psg-block__kind {
  color: var(--brand-primary, #0877bc);
}

.psg-block--finalized .psg-block__name {
  color: color-mix(in srgb, var(--text-color, #0f172a) 78%, #64748b);
}

.psg-block__finalized {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.3;
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--surface-color));
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);
  white-space: nowrap;
}

.psg-block--exercise-sync:not(.psg-block--mismatch):not(.psg-block--selected) {
  box-shadow:
    0 4px 12px color-mix(in srgb, var(--psg-sync, #0d9488) 14%, transparent),
    inset 0 0 0 1px color-mix(in srgb, var(--psg-sync, #0d9488) 18%, transparent);
}

.psg-block__sync {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 6px 1px 4px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.3;
  color: var(--psg-sync, #0d9488);
  background: color-mix(in srgb, var(--psg-sync, #0d9488) 14%, var(--surface-color));
  border: 1px solid color-mix(in srgb, var(--psg-sync, #0d9488) 32%, transparent);
  white-space: nowrap;
}

.psg-block--draggable {
  cursor: grab;
}

.psg-block--draggable:active {
  cursor: grabbing;
}

.psg-block--swap-source {
  border-color: var(--psg-accent, #0877bc);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--psg-accent, #0877bc) 55%, transparent);
  outline: 2px dashed var(--psg-accent, #0877bc);
  outline-offset: 2px;
}

.psg-block--swap-target {
  border-style: dashed;
  border-color: var(--psg-accent, #0877bc);
  background: color-mix(in srgb, var(--psg-accent, #0877bc) 16%, var(--surface-color));
  animation: psg-swap-pulse 1.4s ease-in-out infinite;
}

.psg-block--swap-dim {
  opacity: 0.42;
}

.psg-swap-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-color);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color));
  color: var(--text-color);
  font-size: 13px;
  font-weight: 650;
}

.psg-swap-banner__cancel {
  margin-left: auto;
  min-height: 32px;
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--surface-color);
  color: var(--text-color);
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

@keyframes psg-swap-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 color-mix(in srgb, var(--psg-accent, #0877bc) 35%, transparent);
  }
  50% {
    box-shadow: 0 0 0 4px color-mix(in srgb, var(--psg-accent, #0877bc) 22%, transparent);
  }
}

@media (prefers-reduced-motion: reduce) {
  .psg-block--swap-target {
    animation: none;
  }
}

.psg-block--type-only {
  border-style: dashed;
  background: linear-gradient(
    180deg,
    color-mix(in srgb, var(--psg-accent, #0877bc) 8%, var(--surface-color)),
    var(--surface-color)
  );
}

.psg-block__later {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--psg-accent, #0877bc);
}

.psg-block--empty {
  container-type: inline-size;
  min-width: 108px;
  cursor: default;
  border-style: dashed;
  background:
    repeating-linear-gradient(
      -45deg,
      color-mix(in srgb, var(--psg-accent, #0877bc) 7%, var(--surface-color)),
      color-mix(in srgb, var(--psg-accent, #0877bc) 7%, var(--surface-color)) 8px,
      var(--surface-color) 8px,
      var(--surface-color) 16px
    );
}

.psg-block--empty.psg-block--draggable {
  cursor: grab;
}

.psg-block--empty.psg-block--draggable:active {
  cursor: grabbing;
}

.psg-block--empty .psg-compose {
  margin-top: 6px;
}

.psg-compose {
  display: flex;
  align-items: stretch;
  gap: 6px;
  flex: 0 0 auto;
  align-self: center;
}

.psg-compose__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  box-sizing: border-box;
  min-height: 36px;
  min-width: 0;
  max-width: 100%;
  padding: 6px 10px;
  border: none;
  border-radius: 10px;
  font: inherit;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: -0.01em;
  line-height: 1.2;
  color: #fff;
  cursor: pointer;
  white-space: normal;
  text-align: center;
  overflow: hidden;
  background: linear-gradient(
    135deg,
    var(--psg-accent, #0877bc) 0%,
    color-mix(in srgb, var(--psg-accent, #0877bc) 72%, #000) 100%
  );
  box-shadow: 0 3px 10px color-mix(in srgb, var(--psg-accent, #0877bc) 28%, transparent);
  transition: transform 0.2s var(--psg-ease), box-shadow 0.2s ease;
}

.psg-compose__label {
  min-width: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow-wrap: anywhere;
}

.psg-compose__label--short {
  display: none;
}

.psg-compose__btn:hover {
  transform: translateY(-1px);
}

.psg-compose__btn:active {
  transform: scale(0.97);
}

.psg-compose__btn:focus-visible {
  outline: 2px solid var(--psg-accent, #0877bc);
  outline-offset: 2px;
}

.psg-compose__btn--ghost {
  color: var(--psg-accent, #0877bc);
  background: color-mix(in srgb, var(--psg-accent, #0877bc) 12%, var(--surface-color));
  border: 1px solid color-mix(in srgb, var(--psg-accent, #0877bc) 35%, var(--border-color));
  box-shadow: none;
}

.psg-compose--compact .psg-compose__label {
  display: none;
}

.psg-block__name {
  font-size: 12px;
  font-weight: 750;
  letter-spacing: -0.02em;
  line-height: 1.25;
  color: var(--text-color);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}

.psg-block__mins {
  font-size: 11px;
  font-weight: 700;
  color: var(--psg-accent, #0877bc);
}

.psg-empty {
  flex: 1 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 60px;
  padding: 8px;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}

.psg-empty__btn {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  padding: 6px 12px;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--psg-accent, #0877bc) 40%, var(--border-color));
  background: color-mix(in srgb, var(--psg-accent, #0877bc) 12%, var(--surface-color));
  color: var(--psg-accent, #0877bc);
  font-size: 12px;
  font-weight: 750;
  cursor: pointer;
}

.psg-empty__btn:hover {
  background: color-mix(in srgb, var(--psg-accent, #0877bc) 20%, var(--surface-color));
}

.psg-empty__btn:focus-visible {
  outline: 2px solid var(--psg-accent, #0877bc);
}

/* Above the live-training plan sheet (z-index 4200) and fullscreen page. */
.MuiDialog-root.psg-split-dialog {
  z-index: 4600 !important;
}

/* Split dialog */
.psg-split {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px;
}

.psg-split__field label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 700;
  color: var(--text-secondary);
}

.psg-split__input {
  width: 100%;
  min-height: 44px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  background: var(--bg-color);
  color: var(--text-color);
  font: inherit;
  font-size: 15px;
  font-weight: 600;
}

.psg-split__input:focus {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 1px;
}

.psg-split__modes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.psg-mode {
  text-align: left;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid var(--border-color);
  background: var(--bg-color);
  cursor: pointer;
  color: var(--text-color);
  transition: border-color 0.2s ease, transform 0.2s var(--psg-ease), background 0.2s ease;
}

.psg-mode:hover {
  transform: translateY(-1px);
}

.psg-mode--on {
  border-color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--bg-color));
}

.psg-mode h4 {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 750;
}

.psg-mode p {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--text-secondary);
}

.psg-tables {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.psg-table-chip {
  min-height: 36px;
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid var(--border-color);
  background: var(--bg-color);
  color: var(--text-color);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.psg-table-chip--on {
  border-color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--bg-color));
  color: var(--brand-primary, #0877bc);
}

@media (max-width: 719px) {
  .psg-board {
    --psg-rail: 100%;
    --psg-px: 5px;
    border-radius: 14px;
  }

  .psg-board__hero {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    padding: 8px 10px;
    gap: 8px;
  }

  .psg-board__title {
    font-size: 18px;
  }

  .psg-board__hero-actions {
    width: auto;
    margin-left: auto;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
  }

  .psg-board__split {
    flex: 0 0 auto;
    width: auto;
    min-width: 0;
    max-width: none;
    justify-content: center;
    padding: 8px 12px;
  }

  .psg-board__split-label {
    white-space: nowrap;
  }

  .psg-focus {
    flex-direction: column;
    align-items: stretch;
    padding: 10px 12px;
  }

  .psg-focus__block {
    white-space: normal;
  }

  .psg-focus__actions {
    width: 100%;
  }

  .psg-focus__btn {
    flex: 1 1 auto;
    min-width: 0;
    min-height: 44px;
    font-size: 13px;
  }

  .psg-board__scroll {
    overflow-x: hidden;
    overflow-y: visible;
    padding: 8px 10px 12px;
  }

  .psg-board__grid {
    min-width: 0;
    width: 100%;
    max-width: 100%;
  }

  .psg-ruler {
    display: none;
  }

  .psg-lane {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    min-width: 0;
  }

  .psg-lane__identity {
    border-left-width: 4px;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px 12px;
  }

  .psg-lane__name-row {
    flex: 1 1 140px;
    min-width: 0;
  }

  .psg-lane__name {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    font-size: 16px;
  }

  .psg-lane__actions {
    margin-top: 0;
    margin-left: auto;
  }

  .psg-lane__track {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    flex-direction: column;
    align-items: stretch;
    min-height: 0;
    gap: 8px;
    padding: 8px;
  }

  .psg-block {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    flex: none;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-rows: auto auto;
    column-gap: 10px;
    row-gap: 2px;
    align-items: center;
    min-height: 56px;
    padding: 10px 12px;
  }

  .psg-block__topline {
    grid-column: 1;
    grid-row: 1;
  }

  .psg-block__kind {
    font-size: 13px;
  }

  .psg-block__name {
    grid-column: 1;
    grid-row: 2;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    font-size: 14px;
  }

  .psg-block__meta {
    grid-column: 2;
    grid-row: 1 / span 2;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
  }

  .psg-block__mins {
    font-size: 13px;
  }

  .psg-empty {
    flex-direction: column;
    width: 100%;
  }

  .psg-empty__btn {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  .psg-compose {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .psg-compose__btn {
    flex: 1 1 auto;
    width: 100%;
    min-height: 44px;
    padding: 8px 12px;
  }

  .psg-compose__label--full {
    display: none;
  }

  .psg-compose__label--short {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .psg-compose--compact .psg-compose__label--short {
    display: -webkit-box;
  }

  .psg-compose--compact .psg-compose__label--full {
    display: none;
  }

  .psg-block--empty {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
  }

  .psg-block--empty .psg-compose {
    width: 100%;
  }

  .psg-split__modes {
    grid-template-columns: 1fr;
  }
}

@media (min-width: 720px) {
  .planning-page.planning-page--stations {
    max-width: 1120px;
  }
}

.light-mode .psg-board {
  background: var(--brand-surface, #ffffff);
}
`, "",{"version":3,"sources":["webpack://./src/components/planning/PlanningSubgroupBoard.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,yCAAyC;EACzC,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,gCAAgC;EAChC,qCAAqC;EACrC,0CAA0C;EAC1C,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB;;;;;KAKG;EACH,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4DAA4D;EAC5D,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB;;;;GAIC;EACD,wEAAwE;EACxE,gEAAgE;AAClE;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uFAAuF;EACvF,gBAAgB;EAChB,4FAA4F;AAC9F;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,4CAA4C;EAC5C,sFAAsF;AACxF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,4FAA4F;EAC5F,uFAAuF;EACvF,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,uFAAuF;EACvF,kEAAkE;EAClE,gFAAgF;AAClF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,4FAA4F;EAC5F,4FAA4F;EAC5F,iCAAiC;EACjC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;GAIC;AACH;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;GAIC;AACH;;AAEA;EACE,oCAAoC;EACpC,wFAAwF;EACxF,uFAAuF;AACzF;;AAEA;EACE,cAAc;EACd,kEAAkE;EAClE,iEAAiE;AACnE;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE;IACE,0DAA0D;EAC5D;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,8EAA8E;EAC9E,wFAAwF;AAC1F;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,qFAAqF;EACrF,2FAA2F;AAC7F;;AAEA;EACE;;;;;;GAMC;AACH;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yFAAyF;EACzF,iCAAiC;EACjC,oFAAoF;EACpF,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;EACjC,oFAAoF;EACpF,yFAAyF;AAC3F;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,4BAA4B;EAC5B,eAAe;EACf,oFAAoF;AACtF;;AAEA;EACE,oCAAoC;EACpC,uFAAuF;AACzF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,qEAAqE;EACrE,0FAA0F;AAC5F;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yFAAyF;EACzF,gCAAgC;EAChC,sFAAsF;EACtF,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,2EAA2E;EAC3E,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,sFAAsF;AACxF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,qFAAqF;AACvF;;AAEA;EACE,qBAAqB;EACrB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C;;;;GAIC;AACH;;AAEA;EACE,sBAAsB;EACtB,gDAAgD;EAChD;;;;GAIC;EACD;;sFAEoF;AACtF;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,4EAA4E;EAC5E;;;;;GAKC;EACD;;sFAEoF;EACpF,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,oCAAoC;EACpC,uFAAuF;EACvF,oFAAoF;EACpF,mBAAmB;AACrB;;AAEA;EACE;;iFAE+E;AACjF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,+BAA+B;EAC/B,kFAAkF;EAClF,+EAA+E;EAC/E,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,qFAAqF;EACrF,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,wCAAwC;EACxC,oFAAoF;EACpF,mDAAmD;AACrD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4CAA4C;EAC5C,uFAAuF;EACvF,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;;IAEE,mFAAmF;EACrF;EACA;IACE,qFAAqF;EACvF;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB;;;;GAIC;AACH;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB;;;;;;;KAOG;AACL;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB;;;;GAIC;EACD,sFAAsF;EACtF,gEAAgE;AAClE;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,oFAAoF;EACpF,yFAAyF;EACzF,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yFAAyF;EACzF,oFAAoF;EACpF,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,2EAA2E;AAC3E;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;EACf,wBAAwB;EACxB,wFAAwF;AAC1F;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,kFAAkF;AACpF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,2BAA2B;EAC3B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,kFAAkF;EAClF,oCAAoC;AACtC;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;IACV,aAAa;IACb,0CAA0C;IAC1C,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,aAAa;IACb,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,yCAAyC;AAC3C","sourcesContent":["/* Planning stations — swimlane board */\n\n.psg-board {\n  --psg-ease: cubic-bezier(0.25, 1, 0.5, 1);\n  --psg-rail: 148px;\n  --psg-px: 7px;\n  margin: 0 0 16px;\n  padding: 0;\n  border-radius: 16px;\n  background: var(--surface-color);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 8px 28px var(--shadow-color);\n  overflow: hidden;\n  color: var(--text-color);\n}\n\n.psg-board__hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n  padding: 10px 14px;\n  background:\n    linear-gradient(\n      135deg,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent) 0%,\n      transparent 58%\n    );\n  border-bottom: 1px solid var(--border-color);\n}\n\n.psg-board__hero--toolbar {\n  align-items: center;\n}\n\n.psg-board__titles {\n  flex: 1 1 14rem;\n  min-width: 0;\n}\n\n.psg-board__kicker {\n  margin: 0 0 2px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.psg-board__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 750;\n  letter-spacing: -0.03em;\n  line-height: 1.2;\n  color: var(--text-color);\n}\n\n.psg-board__meta {\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.psg-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 650;\n  line-height: 1.2;\n  background: var(--bg-color);\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n}\n\n.psg-chip--warn {\n  color: #b26a00;\n  background: color-mix(in srgb, #ff9f0a 18%, var(--bg-color));\n  border-color: color-mix(in srgb, #ff9f0a 45%, var(--border-color));\n}\n\n.psg-board__hero-actions {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex: 0 0 auto;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.psg-board__split {\n  box-sizing: border-box;\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: auto;\n  max-width: 100%;\n  min-height: 40px;\n  padding: 8px 12px;\n  border: none;\n  border-radius: 12px;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 750;\n  letter-spacing: -0.01em;\n  line-height: 1.2;\n  color: #fff;\n  cursor: pointer;\n  white-space: nowrap;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877bc) 0%,\n    var(--brand-primary-dark, #065a8f) 100%\n  );\n  box-shadow: 0 4px 14px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.32);\n  transition: transform 0.2s var(--psg-ease), box-shadow 0.2s ease;\n}\n\n.psg-board__split-icon {\n  flex-shrink: 0;\n}\n\n.psg-board__split-label {\n  display: inline;\n  min-width: 0;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.psg-board__split:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.4);\n}\n\n.psg-board__split:active {\n  transform: scale(0.97);\n}\n\n.psg-board__split:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.psg-board__split:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.psg-board__split--ghost {\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color));\n  box-shadow: none;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--border-color));\n}\n\n.psg-focus {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--border-color);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color));\n}\n\n.psg-focus__copy {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  gap: 1px;\n}\n\n.psg-focus__station {\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.psg-focus__block {\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--text-color);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.psg-focus__block--muted {\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.psg-focus__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.psg-focus__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 36px;\n  padding: 6px 12px;\n  border-radius: 10px;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, var(--border-color));\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));\n  color: var(--brand-primary, #0877bc);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.dark-mode .psg-focus__btn,\nhtml[data-theme=\"dark\"] .psg-focus__btn {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color));\n  color: color-mix(in srgb, var(--brand-primary, #0877bc) 50%, #fff);\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 38%, transparent);\n}\n\n.template-apply-choice {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  width: 100%;\n  text-align: left;\n  padding: 14px 16px;\n  border-radius: 14px;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, var(--border-color));\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color, #fff));\n  color: var(--text-color, #1a1a1a);\n  font: inherit;\n  cursor: pointer;\n}\n\n.template-apply-choice strong {\n  font-size: 15px;\n  font-weight: 750;\n}\n\n.template-apply-choice span {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary, #555);\n}\n\n.template-apply-choice--primary {\n  color: #fff;\n  border: none;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877bc) 0%,\n    var(--brand-primary-dark, #065a8f) 100%\n  );\n}\n\n.template-apply-choice--primary span {\n  color: rgba(255, 255, 255, 0.88);\n}\n\n.psg-focus__btn--primary {\n  color: #fff;\n  border: none;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877bc) 0%,\n    var(--brand-primary-dark, #065a8f) 100%\n  );\n}\n\n.psg-focus__btn--ghost {\n  color: var(--brand-primary, #0877bc);\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--border-color));\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));\n}\n\n.psg-focus__btn--danger {\n  color: #c62828;\n  border-color: color-mix(in srgb, #c62828 35%, var(--border-color));\n  background: color-mix(in srgb, #c62828 10%, var(--surface-color));\n}\n\n.psg-board__scroll {\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  padding: 8px 12px 16px;\n}\n\n.psg-board__grid {\n  min-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n@media (min-width: 720px) {\n  .psg-board__grid {\n    min-width: calc(var(--psg-rail) + var(--psg-track, 280px));\n  }\n\n  .psg-ruler__track,\n  .psg-lane__track {\n    width: var(--psg-track, 280px);\n  }\n\n  .psg-block {\n    width: var(--psg-block-w, 72px);\n  }\n}\n\n.psg-ruler {\n  display: grid;\n  grid-template-columns: var(--psg-rail) 1fr;\n  align-items: end;\n  min-height: 28px;\n  padding: 0 4px 4px;\n}\n\n.psg-ruler__label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  padding-left: 4px;\n}\n\n.psg-ruler__track {\n  position: relative;\n  height: 22px;\n}\n\n.psg-ruler__tick {\n  position: absolute;\n  top: 0;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  color: var(--text-secondary);\n  font-size: 10px;\n  font-weight: 650;\n}\n\n.psg-ruler__tick::before {\n  content: \"\";\n  width: 1px;\n  height: 8px;\n  margin-bottom: 2px;\n  background: var(--border-color);\n}\n\n.psg-lane {\n  display: grid;\n  grid-template-columns: var(--psg-rail) 1fr;\n  gap: 8px;\n  padding: 8px;\n  border-radius: 14px;\n  border: 1px solid transparent;\n  background: color-mix(in srgb, var(--psg-accent, #0877bc) 7%, var(--bg-color));\n  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s var(--psg-ease);\n}\n\n.psg-lane:hover {\n  background: color-mix(in srgb, var(--psg-accent, #0877bc) 11%, var(--bg-color));\n}\n\n.psg-lane--selected {\n  border-color: color-mix(in srgb, var(--psg-accent, #0877bc) 55%, var(--border-color));\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--psg-accent, #0877bc) 35%, transparent);\n}\n\n.psg-lane--independent .psg-lane__track {\n  background-image: repeating-linear-gradient(\n    -45deg,\n    transparent,\n    transparent 7px,\n    color-mix(in srgb, var(--psg-accent, #0877bc) 8%, transparent) 7px,\n    color-mix(in srgb, var(--psg-accent, #0877bc) 8%, transparent) 14px\n  );\n}\n\n.psg-lane__identity {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  padding: 4px 2px 4px 6px;\n  border-left: 4px solid var(--psg-accent, #0877bc);\n  border-radius: 0 8px 8px 0;\n}\n\n.psg-lane__name-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.psg-lane__name {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  color: var(--text-color);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.psg-lane__name-input {\n  width: 100%;\n  min-width: 0;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--surface-color);\n  color: var(--text-color);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 4px 8px;\n}\n\n.psg-lane__timer {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  max-width: 100%;\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 750;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  border: 1px solid color-mix(in srgb, var(--psg-accent, #0877bc) 40%, var(--border-color));\n  color: var(--psg-accent, #0877bc);\n  background: color-mix(in srgb, var(--psg-accent, #0877bc) 12%, var(--surface-color));\n  cursor: pointer;\n}\n\n.psg-lane__timer:disabled {\n  cursor: default;\n  opacity: 0.85;\n}\n\n.psg-lane__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.psg-lane__tables {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.psg-lane__table {\n  display: inline-flex;\n  align-items: center;\n  min-height: 22px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 750;\n  letter-spacing: 0.02em;\n  color: var(--psg-accent, #0877bc);\n  background: color-mix(in srgb, var(--psg-accent, #0877bc) 14%, var(--surface-color));\n  border: 1px solid color-mix(in srgb, var(--psg-accent, #0877bc) 32%, var(--border-color));\n}\n\n.psg-lane__actions {\n  display: flex;\n  gap: 4px;\n  margin-top: auto;\n}\n\n.psg-icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border-radius: 9px;\n  border: 1px solid var(--border-color);\n  background: var(--surface-color);\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: transform 0.15s var(--psg-ease), background 0.15s ease, color 0.15s ease;\n}\n\n.psg-icon-btn:hover {\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));\n}\n\n.psg-icon-btn:active {\n  transform: scale(0.94);\n}\n\n.psg-icon-btn:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 1px;\n}\n\n.psg-icon-btn--danger:hover {\n  color: #c62828;\n  background: color-mix(in srgb, #c62828 12%, var(--surface-color));\n}\n\n.psg-lane__track {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  gap: 6px;\n  min-height: 76px;\n  padding: 8px;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--surface-color) 70%, transparent);\n  border: 1px dashed color-mix(in srgb, var(--psg-accent, #0877bc) 28%, var(--border-color));\n}\n\n.psg-block {\n  position: relative;\n  flex: 0 0 auto;\n  min-width: 72px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n  padding: 8px 10px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--psg-accent, #0877bc) 35%, var(--border-color));\n  background: var(--surface-color);\n  box-shadow: 0 4px 12px color-mix(in srgb, var(--psg-accent, #0877bc) 16%, transparent);\n  cursor: pointer;\n  text-align: left;\n  color: inherit;\n  transition: transform 0.2s var(--psg-ease), box-shadow 0.2s ease;\n}\n\n.psg-block__topline {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.psg-block__index {\n  flex: 0 0 auto;\n  min-width: 1.7rem;\n  padding: 1px 5px;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--psg-accent, #0877bc) 14%, transparent);\n  color: var(--psg-accent, #0877bc);\n  font-size: 11px;\n  font-weight: 750;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.04em;\n  line-height: 1.4;\n}\n\n.psg-block__kind {\n  min-width: 0;\n  font-size: 12px;\n  font-weight: 750;\n  letter-spacing: 0.01em;\n  color: var(--psg-accent, #0877bc);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.psg-block__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.psg-block__seqs {\n  font-size: 10px;\n  font-weight: 650;\n  color: var(--text-secondary);\n}\n\n.psg-block:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 18px color-mix(in srgb, var(--psg-accent, #0877bc) 22%, transparent);\n}\n\n.psg-block:active {\n  transform: scale(0.98);\n}\n\n.psg-block:focus-visible {\n  outline: 2px solid var(--psg-accent, #0877bc);\n  outline-offset: 2px;\n}\n\n.psg-block--selected {\n  border-color: var(--psg-accent, #0877bc);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--psg-accent, #0877bc) 35%, transparent);\n}\n\n.psg-block--mismatch {\n  border-color: #ff9f0a;\n  box-shadow: 0 0 0 2px color-mix(in srgb, #ff9f0a 45%, transparent);\n}\n\n.psg-block--exercise-sync {\n  border-left-width: 4px;\n  border-left-color: var(--psg-sync, #0d9488);\n  background: linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--psg-sync, #0d9488) 12%, var(--surface-color)) 0,\n    var(--surface-color) 18px\n  );\n}\n\n.psg-block--personalized {\n  border-left-width: 4px;\n  border-left-color: var(--brand-primary, #0877bc);\n  background: linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color)) 0,\n    var(--surface-color) 22px\n  );\n  box-shadow:\n    0 4px 12px color-mix(in srgb, var(--brand-primary, #0877bc) 16%, transparent),\n    inset 0 0 0 1px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n}\n\n.psg-block--personalized .psg-block__kind {\n  color: var(--brand-primary, #0877bc);\n  font-weight: 800;\n}\n\n.psg-block--finalized {\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 45%, #94a3b8);\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color)) 0%,\n    color-mix(in srgb, var(--brand-primary, #0877bc) 5%, var(--surface-color)) 55%,\n    var(--surface-color) 100%\n  );\n  box-shadow:\n    0 4px 12px color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent),\n    inset 0 0 0 1px color-mix(in srgb, var(--brand-primary, #0877bc) 18%, transparent);\n  opacity: 0.92;\n}\n\n.psg-block--finalized .psg-block__kind {\n  color: var(--brand-primary, #0877bc);\n}\n\n.psg-block--finalized .psg-block__name {\n  color: color-mix(in srgb, var(--text-color, #0f172a) 78%, #64748b);\n}\n\n.psg-block__finalized {\n  display: inline-flex;\n  align-items: center;\n  padding: 1px 7px;\n  border-radius: 999px;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.3;\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--surface-color));\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);\n  white-space: nowrap;\n}\n\n.psg-block--exercise-sync:not(.psg-block--mismatch):not(.psg-block--selected) {\n  box-shadow:\n    0 4px 12px color-mix(in srgb, var(--psg-sync, #0d9488) 14%, transparent),\n    inset 0 0 0 1px color-mix(in srgb, var(--psg-sync, #0d9488) 18%, transparent);\n}\n\n.psg-block__sync {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 1px 6px 1px 4px;\n  border-radius: 999px;\n  font-size: 9px;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1.3;\n  color: var(--psg-sync, #0d9488);\n  background: color-mix(in srgb, var(--psg-sync, #0d9488) 14%, var(--surface-color));\n  border: 1px solid color-mix(in srgb, var(--psg-sync, #0d9488) 32%, transparent);\n  white-space: nowrap;\n}\n\n.psg-block--draggable {\n  cursor: grab;\n}\n\n.psg-block--draggable:active {\n  cursor: grabbing;\n}\n\n.psg-block--swap-source {\n  border-color: var(--psg-accent, #0877bc);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--psg-accent, #0877bc) 55%, transparent);\n  outline: 2px dashed var(--psg-accent, #0877bc);\n  outline-offset: 2px;\n}\n\n.psg-block--swap-target {\n  border-style: dashed;\n  border-color: var(--psg-accent, #0877bc);\n  background: color-mix(in srgb, var(--psg-accent, #0877bc) 16%, var(--surface-color));\n  animation: psg-swap-pulse 1.4s ease-in-out infinite;\n}\n\n.psg-block--swap-dim {\n  opacity: 0.42;\n}\n\n.psg-swap-banner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--border-color);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color));\n  color: var(--text-color);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.psg-swap-banner__cancel {\n  margin-left: auto;\n  min-height: 32px;\n  padding: 4px 10px;\n  border-radius: 8px;\n  border: 1px solid var(--border-color);\n  background: var(--surface-color);\n  color: var(--text-color);\n  font: inherit;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n@keyframes psg-swap-pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 color-mix(in srgb, var(--psg-accent, #0877bc) 35%, transparent);\n  }\n  50% {\n    box-shadow: 0 0 0 4px color-mix(in srgb, var(--psg-accent, #0877bc) 22%, transparent);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .psg-block--swap-target {\n    animation: none;\n  }\n}\n\n.psg-block--type-only {\n  border-style: dashed;\n  background: linear-gradient(\n    180deg,\n    color-mix(in srgb, var(--psg-accent, #0877bc) 8%, var(--surface-color)),\n    var(--surface-color)\n  );\n}\n\n.psg-block__later {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--psg-accent, #0877bc);\n}\n\n.psg-block--empty {\n  container-type: inline-size;\n  min-width: 108px;\n  cursor: default;\n  border-style: dashed;\n  background:\n    repeating-linear-gradient(\n      -45deg,\n      color-mix(in srgb, var(--psg-accent, #0877bc) 7%, var(--surface-color)),\n      color-mix(in srgb, var(--psg-accent, #0877bc) 7%, var(--surface-color)) 8px,\n      var(--surface-color) 8px,\n      var(--surface-color) 16px\n    );\n}\n\n.psg-block--empty.psg-block--draggable {\n  cursor: grab;\n}\n\n.psg-block--empty.psg-block--draggable:active {\n  cursor: grabbing;\n}\n\n.psg-block--empty .psg-compose {\n  margin-top: 6px;\n}\n\n.psg-compose {\n  display: flex;\n  align-items: stretch;\n  gap: 6px;\n  flex: 0 0 auto;\n  align-self: center;\n}\n\n.psg-compose__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  box-sizing: border-box;\n  min-height: 36px;\n  min-width: 0;\n  max-width: 100%;\n  padding: 6px 10px;\n  border: none;\n  border-radius: 10px;\n  font: inherit;\n  font-size: 12px;\n  font-weight: 750;\n  letter-spacing: -0.01em;\n  line-height: 1.2;\n  color: #fff;\n  cursor: pointer;\n  white-space: normal;\n  text-align: center;\n  overflow: hidden;\n  background: linear-gradient(\n    135deg,\n    var(--psg-accent, #0877bc) 0%,\n    color-mix(in srgb, var(--psg-accent, #0877bc) 72%, #000) 100%\n  );\n  box-shadow: 0 3px 10px color-mix(in srgb, var(--psg-accent, #0877bc) 28%, transparent);\n  transition: transform 0.2s var(--psg-ease), box-shadow 0.2s ease;\n}\n\n.psg-compose__label {\n  min-width: 0;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow-wrap: anywhere;\n}\n\n.psg-compose__label--short {\n  display: none;\n}\n\n.psg-compose__btn:hover {\n  transform: translateY(-1px);\n}\n\n.psg-compose__btn:active {\n  transform: scale(0.97);\n}\n\n.psg-compose__btn:focus-visible {\n  outline: 2px solid var(--psg-accent, #0877bc);\n  outline-offset: 2px;\n}\n\n.psg-compose__btn--ghost {\n  color: var(--psg-accent, #0877bc);\n  background: color-mix(in srgb, var(--psg-accent, #0877bc) 12%, var(--surface-color));\n  border: 1px solid color-mix(in srgb, var(--psg-accent, #0877bc) 35%, var(--border-color));\n  box-shadow: none;\n}\n\n.psg-compose--compact .psg-compose__label {\n  display: none;\n}\n\n.psg-block__name {\n  font-size: 12px;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  color: var(--text-color);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n}\n\n.psg-block__mins {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--psg-accent, #0877bc);\n}\n\n.psg-empty {\n  flex: 1;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 60px;\n  padding: 8px;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.psg-empty__btn {\n  display: inline-flex;\n  align-items: center;\n  min-height: 36px;\n  padding: 6px 12px;\n  border-radius: 10px;\n  border: 1px solid color-mix(in srgb, var(--psg-accent, #0877bc) 40%, var(--border-color));\n  background: color-mix(in srgb, var(--psg-accent, #0877bc) 12%, var(--surface-color));\n  color: var(--psg-accent, #0877bc);\n  font-size: 12px;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.psg-empty__btn:hover {\n  background: color-mix(in srgb, var(--psg-accent, #0877bc) 20%, var(--surface-color));\n}\n\n.psg-empty__btn:focus-visible {\n  outline: 2px solid var(--psg-accent, #0877bc);\n}\n\n/* Above the live-training plan sheet (z-index 4200) and fullscreen page. */\n.MuiDialog-root.psg-split-dialog {\n  z-index: 4600 !important;\n}\n\n/* Split dialog */\n.psg-split {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-top: 8px;\n}\n\n.psg-split__field label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-secondary);\n}\n\n.psg-split__input {\n  width: 100%;\n  min-height: 44px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  background: var(--bg-color);\n  color: var(--text-color);\n  font: inherit;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.psg-split__input:focus {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 1px;\n}\n\n.psg-split__modes {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.psg-mode {\n  text-align: left;\n  padding: 12px;\n  border-radius: 14px;\n  border: 1px solid var(--border-color);\n  background: var(--bg-color);\n  cursor: pointer;\n  color: var(--text-color);\n  transition: border-color 0.2s ease, transform 0.2s var(--psg-ease), background 0.2s ease;\n}\n\n.psg-mode:hover {\n  transform: translateY(-1px);\n}\n\n.psg-mode--on {\n  border-color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--bg-color));\n}\n\n.psg-mode h4 {\n  margin: 0 0 4px;\n  font-size: 14px;\n  font-weight: 750;\n}\n\n.psg-mode p {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--text-secondary);\n}\n\n.psg-tables {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.psg-table-chip {\n  min-height: 36px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--border-color);\n  background: var(--bg-color);\n  color: var(--text-color);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.psg-table-chip--on {\n  border-color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--bg-color));\n  color: var(--brand-primary, #0877bc);\n}\n\n@media (max-width: 719px) {\n  .psg-board {\n    --psg-rail: 100%;\n    --psg-px: 5px;\n    border-radius: 14px;\n  }\n\n  .psg-board__hero {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    padding: 8px 10px;\n    gap: 8px;\n  }\n\n  .psg-board__title {\n    font-size: 18px;\n  }\n\n  .psg-board__hero-actions {\n    width: auto;\n    margin-left: auto;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 8px;\n    flex: 0 0 auto;\n  }\n\n  .psg-board__split {\n    flex: 0 0 auto;\n    width: auto;\n    min-width: 0;\n    max-width: none;\n    justify-content: center;\n    padding: 8px 12px;\n  }\n\n  .psg-board__split-label {\n    white-space: nowrap;\n  }\n\n  .psg-focus {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 10px 12px;\n  }\n\n  .psg-focus__block {\n    white-space: normal;\n  }\n\n  .psg-focus__actions {\n    width: 100%;\n  }\n\n  .psg-focus__btn {\n    flex: 1 1 auto;\n    min-width: 0;\n    min-height: 44px;\n    font-size: 13px;\n  }\n\n  .psg-board__scroll {\n    overflow-x: hidden;\n    overflow-y: visible;\n    padding: 8px 10px 12px;\n  }\n\n  .psg-board__grid {\n    min-width: 0;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .psg-ruler {\n    display: none;\n  }\n\n  .psg-lane {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px;\n    min-width: 0;\n  }\n\n  .psg-lane__identity {\n    border-left-width: 4px;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: 8px 12px;\n  }\n\n  .psg-lane__name-row {\n    flex: 1 1 140px;\n    min-width: 0;\n  }\n\n  .psg-lane__name {\n    white-space: normal;\n    overflow: visible;\n    text-overflow: unset;\n    font-size: 16px;\n  }\n\n  .psg-lane__actions {\n    margin-top: 0;\n    margin-left: auto;\n  }\n\n  .psg-lane__track {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    flex-direction: column;\n    align-items: stretch;\n    min-height: 0;\n    gap: 8px;\n    padding: 8px;\n  }\n\n  .psg-block {\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    flex: none;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    grid-template-rows: auto auto;\n    column-gap: 10px;\n    row-gap: 2px;\n    align-items: center;\n    min-height: 56px;\n    padding: 10px 12px;\n  }\n\n  .psg-block__topline {\n    grid-column: 1;\n    grid-row: 1;\n  }\n\n  .psg-block__kind {\n    font-size: 13px;\n  }\n\n  .psg-block__name {\n    grid-column: 1;\n    grid-row: 2;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    font-size: 14px;\n  }\n\n  .psg-block__meta {\n    grid-column: 2;\n    grid-row: 1 / span 2;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 2px;\n  }\n\n  .psg-block__mins {\n    font-size: 13px;\n  }\n\n  .psg-empty {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .psg-empty__btn {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  .psg-compose {\n    width: 100%;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .psg-compose__btn {\n    flex: 1 1 auto;\n    width: 100%;\n    min-height: 44px;\n    padding: 8px 12px;\n  }\n\n  .psg-compose__label--full {\n    display: none;\n  }\n\n  .psg-compose__label--short {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    line-clamp: 2;\n    -webkit-box-orient: vertical;\n  }\n\n  .psg-compose--compact .psg-compose__label--short {\n    display: -webkit-box;\n  }\n\n  .psg-compose--compact .psg-compose__label--full {\n    display: none;\n  }\n\n  .psg-block--empty {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 6px;\n  }\n\n  .psg-block--empty .psg-compose {\n    width: 100%;\n  }\n\n  .psg-split__modes {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (min-width: 720px) {\n  .planning-page.planning-page--stations {\n    max-width: 1120px;\n  }\n}\n\n.light-mode .psg-board {\n  background: var(--brand-surface, #ffffff);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
